import type React from "react";

import { SERVICEABILITY_ADDRESS_NR_MASK_PROPS } from "@/constants/newRelicSessionReplay";
import type { ServiceabilityAddressSuggestion } from "@/types/serviceability";

type AddressSuggestionButtonProps = {
  address: ServiceabilityAddressSuggestion;
  onSelect: (address: ServiceabilityAddressSuggestion) => void;
};

const AddressSuggestionButton: React.FC<AddressSuggestionButtonProps> = ({
  address,
  onSelect,
}) => (
  <button
    type="button"
    className="w-full rounded-md border border-neutral-300 bg-white px-4 py-3 text-left text-sm text-neutral-900 transition-colors hover:border-neutral-500"
    onClick={() => onSelect(address)}
    {...SERVICEABILITY_ADDRESS_NR_MASK_PROPS}
  >
    {address.fullAddress}
  </button>
);

export default AddressSuggestionButton;
